module.exports = __webpack_public_path__ + "static/img/104163.608047f5.png";